import { render, staticRenderFns } from "./MainFullView.vue?vue&type=template&id=25d86ae3&scoped=true&"
import script from "./MainFullView.vue?vue&type=script&lang=js&"
export * from "./MainFullView.vue?vue&type=script&lang=js&"
import style0 from "./MainFullView.vue?vue&type=style&index=0&id=25d86ae3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d86ae3",
  null
  
)

component.options.__file = "MainFullView.vue"
export default component.exports